import React from "react";
import AccordionSection from "@profile/pages/AccountPage/components/AccordionSection/AccordionSection";

type Props = {
  faq: {
    title: string;
    description: JSX.Element;
  }[];
};

export const Faq = ({ faq }: Props) => (
  <div className="">
    <div className="bg-white rounded flex-[2_1_60%]">
      {faq.length !== 0 && (
        <div>
          {faq.map(({ title, description }) => (
            <AccordionSection
              key={title}
              mobileWidth={5600}
              clickableLabel
              label={title}
            >
              {description}
            </AccordionSection>
          ))}
        </div>
      )}
    </div>
  </div>
);
